namespace TabAurous.OMS {
    export interface KaratRateForm {
        CostId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        FromWt: Serenity.DecimalEditor;
        ToWt: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        PurStdRate: AmountEditor;
        SaleStdRate: AmountEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.IntegerEditor;
    }

    export class KaratRateForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.KaratRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!KaratRateForm.init)  {
                KaratRateForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = AmountEditor;
                var w5 = s.IntegerEditor;

                Q.initFormType(KaratRateForm, [
                    'CostId', w0,
                    'ProductTypeId', w1,
                    'KaratId', w1,
                    'FromWt', w2,
                    'ToWt', w2,
                    'FromDate', w3,
                    'ToDate', w3,
                    'PurStdRate', w4,
                    'SaleStdRate', w4,
                    'ProductId', w0,
                    'AttributeId', w5
                ]);
            }
        }
    }
}
